export default function NotFound() {
  return (
    <h1 
      className="not-found"
      style={{ paddingTop: '66px', paddingLeft: '20px' }}
    >
      Page Not Found
    </h1>
  )
}